// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"d80b67eb","100":"3e41f68b","165":"e6137fbe","370":"cf49c750","551":"5344a11c","612":"fb5247da","641":"61e8e012"}[chunkId] + ".chunk.js";
};